export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";